import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_BACK_NODE}/cuentaCorriente`

/**
 * Retorna empresas paginadas con su estado de CC.
 * @param {string} empidVendedor
 * @param {number} pagina - 1-based
 * @param {number} pageSize
 * @param {string} busqueda - Filtro por razón social o empId
 */
export const obtenerEmpresas = (empidVendedor, pagina, pageSize, busqueda) => {
  return http.post(`${API_ENDPOINT}/empresas`, { empidVendedor, pagina, pageSize, busqueda })
}

/**
 * Verifica si una empresa compradora tiene cuenta corriente habilitada por la vendedora.
 * @param {string} empidVendedor
 * @param {string} empidComprador
 */
export const getCuentaCorrienteHabilitacion = (empidVendedor, empidComprador) => {
  return http.post(`${API_ENDPOINT}/habilitacion`, { empidVendedor, empidComprador })
}

/**
 * Crea o actualiza un registro de habilitación de cuenta corriente.
 * @param {{ empidVendedor: string, empidComprador: string, habilita: boolean, condicionPago: number|null }} data
 */
export const guardarHabilitacion = (data) => {
  return http.post(`${API_ENDPOINT}/guardarHabilitacion`, data)
}

/**
 * Actualiza la condición de pago de todos los registros del vendedor.
 * @param {string} empidVendedor
 * @param {number|null} condicionPago
 */
export const guardarHabilitacionMasiva = (empidVendedor, condicionPago) => {
  return http.post(`${API_ENDPOINT}/guardarHabilitacionMasiva`, { empidVendedor, condicionPago })
}
